import http from "@/api/http.js";

export default {
  getShipFromAddresses(departamentoId) {
    return http.get("/ship_from_addresses", {
      params: { departamento_id: departamentoId }
    });
  },

  savePackages(orderUUID, packages) {
    return http.put(`/orders/warehouse_package/${orderUUID}`, { packages });
  },

  getRates(orderUUID, params = {}) {
    return http.post(`/orders/warehouse_rates/${orderUUID}`, params);
  },

  shipOrder(orderUUID, rateId) {
    return http.put(`/orders/warehouse_ship/${orderUUID}`, { rate_id: rateId });
  },

  voidLabel(shipmentUUID) {
    return http.put(`/orders/warehouse_void_label/${shipmentUUID}`);
  }
};
